module.exports = __webpack_public_path__ + "static/media/icons8-linkedin.8b18c95b.svg";